import { faSparkles } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/design-system/Pill";

type NewPillProps = {
  dataLoc?: string;
};

export const NewPill: React.FC<NewPillProps> = ({ dataLoc }) => (
  <Pill dataLoc={dataLoc} size="sm" variant="indigo-light">
    <Pill.Icon icon={faSparkles} />
    <Pill.Text>New</Pill.Text>
  </Pill>
);
